import { OnWacDropDown } from './onwac/onwac-dropdown.model';
import { OnWacSelect } from './onwac/onwac-select.model';

export interface FunnelColModel {
    [x: string]: any;
    identifier: string;
    key: string;
    name: string;
    order: number;
    secondary_state: boolean;
    note_required: boolean;
    deals_history: DealCardModel[];
    loadIndexRange: { min: number; max: number };
    settingsMenu?: OnWacDropDown;
    discard_deals: boolean;
    filled_questions_required: number[];
}

export interface PipelineQuestionI {
    id: number;
    name: string;
    format?: string;
    kind?: string;
    required?: boolean;
}

export interface DealMinI {
    id: number;
    name: string;
    scoring?: string | number;
}

export interface DealCardModel {
    id: string;
    name: string;
    deal?: Deal;
    user_data: DealUserModel;
    scoring: number | string;
    highlighted_questions: HighlitedQuestion[];
    updated_at: string;
    notifications_enabled: boolean;
    system_change_warning: boolean;
    associated_pipelines?: PipelineI[];
    currentPipelineKey?: string; // KEY of the current pipeline
}

export interface DealLocationInFunnelI {
    column: DealCardModel[];
    position: number;
}

export interface DealUserModel {
    first_name: string;
    phone: string;
    email: string;
    avatar: string;
}

export interface HighlitedQuestion {
    question: string;
    answer: string;
}

export interface PipelineI {
    default: boolean;
    identifier: string;
    key: string;
    name: string;
    current?: boolean;
    pipelineColumns?: OnWacSelect;
}

export interface Deal {
    id: string;
    name: string;
    notifications_enabled: boolean;
    scoring: string | number;
    sector: any;
    user_data: any;
    highlighted_questions: HighlitedQuestion[];
    coordinator_data: any;
    associated_pipelines: PipelineI[];
}

export interface DealNoteI {
    title: string;
    content: string;
    internal: boolean;
}

export interface DealFlowMovementI {
    pipeline: string;
    fund: string;
    step: string;
    deal: string;
    note?: DealNoteI;
}

export interface DealflowScoringI {
    text: string;
    name_id: string;
}

export interface DealflowStepI {
    identifier: string;
    key: string;
    name: string;
    order: number;
    scoring: string;
}

export interface DealImporterTableI {
    headers: string[];
    rows: string[][];
    requiredColumns?: string[];
    separator?: string;
}
export type rowStatus = 'OK' | 'ERROR';

export interface DealImporterRowI {
    content: string[];
    status: rowStatus;
    errorMsg?: string;
}

export interface DealImporterError {
    title: string;
    text: string;
}

export class DealImporterTable {
    public headers: string[] = [];
    public rows: DealImporterRowI[] = [];
    public requiredColumns: string[] = [];
    private separator: string = ';';

    constructor(table: DealImporterTableI) {
        this.headers = table.headers;
        // this.requiredColumns = this.setRequiredColumns(
        //     table.requiredColumns || []
        // );
        this.requiredColumns = table.requiredColumns || [];
        this.separator = table.separator || this.separator;
        this.setRows(table.rows);
    }

    setRequiredColumns(requiredColumns: string[]): string[] {
        for (let i = 0; i < requiredColumns.length; i++) {
            const rc = requiredColumns[i];
            if (!this.headers.includes(rc)) requiredColumns.splice(i, 1);
        }
        return requiredColumns;
    }

    removeUndefinedRows(rows: Array<string[]>): string[][] {
        return rows.filter((row) => row);
    }

    removeEmptyRows(): void {
        this.rows = this.rows.filter((row) => row.content.length > 1);
    }

    setRows(rows: string[][]): void {
        rows = this.removeUndefinedRows(rows);
        this.rows = this.requiredColumns.length
            ? rows.map((row) => this.checkRow(row))
            : rows.map((row) => {
                  return { status: 'OK', content: row };
              });
        this.removeEmptyRows();
    }

    checkRow(row: string[]): DealImporterRowI {
        let error = false;
        let missedFields = [];
        this.requiredColumns.forEach((rc: string) => {
            const headerIndex = this.headers.indexOf(rc);
            if (!row[headerIndex]) {
                error = true;
                missedFields.push(rc);
            }
        });
        return {
            status: error ? 'ERROR' : 'OK',
            content: row,
            errorMsg: missedFields.join(),
        };
    }
}
